import React from 'react';


class RhinoSelect extends React.Component {


  getParentClass() {
    let baseClass = 'RhinoSelect';
    if(this.props.selectClass) {
      baseClass = baseClass + ' ' + this.props.selectClass;
    }
    if(this.props.error) {
      baseClass = baseClass + ' error';
    }
    return baseClass;
  }

  blurAction(evt) {
    if(this.props.blurMethod) {
      this.props.blurMethod();
    }
  }

  render() {
    return (
      <div className={this.getParentClass()}>
        <select 
          disabled={this.props.disabled}
          onBlur={this.blurAction.bind(this)}
          onChange={this.props.changeMethod.bind(this)}
          value={this.props.value !== null ? this.props.value : this.props.options[0].value}>
          {this.props.options.map((option, i) => {
            return <option 
              key={i} 
              value={option.value}
              className={!option.value ? 'defaultOption' : 'selectableOption'}>
              {option.display}
            </option>;
          })}
        </select>
        <div className='select__arrow'></div>
      </div>
    );
  }
}
export default RhinoSelect;